import {Typography} from '@mui/material';

export default function Hero() {
  return (
    <>
      <Typography variant="h2" component="h1">
        🚀 Helping Etsy Sellers Save Time & Boost Sales
      </Typography>
      <Typography variant="h4">Smarter Tools for Etsy Sellers Are Here</Typography>
      <Typography variant="subtitle1">
        We&apos;re building the ultimate support tool for Etsy sellers—starting with powerful bulk title and tag
        management to boost your SEO. Crafty Smile is now live and evolving fast. Join us on the journey and start
        growing your shop more efficiently today!
      </Typography>
    </>
  );
}
